export default __webpack_public_path__ + "static/media/app-qrcode.4ce33695.png";